import { mockRbac } from 'src/__mocks__/rback/rbac.mock';
import { IRbac } from '../__shared/rbac.interfaces';
import { createHttpService } from '../ApiService';
import { IAuthParams, ILoggedInUser } from './auth.interfaces';
import isAppWithMock from 'src/utils/isAppWithMock';

export const useAuthService = () => {
  const httpAPI = createHttpService();
  const subBaseEndPoint = '/signin';
  const withMockData = isAppWithMock();

  const authoriseUser = (requestObj: IAuthParams): Promise<ILoggedInUser> => {
    // In mock mode, check for guardian login
    if (withMockData && requestObj.username === 'guardian' && requestObj.password === 'guardian') {
      return Promise.resolve({
        email: 'guardian@example.com',
        firstName: 'Guardian',
        id: 'guardian-1',
        lastName: 'User',
        roles: ['guardian'],
        token: 'mock-guardian-token',
        type: 'guardian',
        username: 'guardian',
        tokenType: 'Bearer',
      });
    }
    return httpAPI.auth.post<ILoggedInUser>(`${subBaseEndPoint}`, requestObj);
  };

  const getRbac = (): Promise<IRbac> => {
    if (withMockData) {
      return Promise.resolve(mockRbac);
    }
    return httpAPI.rbac.get<IRbac>('');
  };

  return {
    authoriseUser,
    getRbac,
  };
};
